<template>
	<div class="multi">
		<el-dialog :title="title" :width="width" :visible.sync="dialogMultiVisible">
			<div class="tipsBox">
				<tips-box></tips-box>
			</div>
			<div class="product_box">
				<product-box :row="row" :tabName="tabName"></product-box>
			</div>
			<div class="user_info_box mt-10">
				<user-info-box :row="row"></user-info-box>
			</div>
			<div class="mt-20">
				<p v-if="state === 2" class="yx-color-text-primary">移出选品表的商品，将不在选品表中展示，可以查看历史推品记录重新加入</p>
				<p v-if="state === 1" class="yx-color-text-primary">移除商品后，再次合作需要重新将商品加入选品表</p>
				<p v-if="state === 3" class="yx-color-text-primary"
					>当达人已经有样品或无需样品进行开播的情况下，可以提前确认收货，将申样中的商品加入到待播池中</p
				>
				<div v-if="state === 4">
					<p class="font-bold yx-color-text-primary fz-14">{{linkNameCom }}</p>
					<p class="yx-color-text-regular mt-12 fz-14">1、复制商品带货链接；</p>
					<p class="yx-color-text-regular mt-6 fz-14">2、打开达人工作台-直播管理-橱窗商品管理-商品链接，将商品带货链接粘贴在文本框中；</p>
					<p class="yx-color-text-regular mt-6 fz-14"> 3、在商品橱窗查看商品头图、售价、佣金、规格等是否符合要求；</p>
					<div class="line mt-16"></div>
					<div class="flex flex-just-between flex-align-center mt-24">
						<p class="font-bold yx-color-text-primary fz-14">{{ goodNameCom}}</p>
						<p class="yx-color-primary fz-14 copy" @click="copy">{{ goodCopyCom }}</p>
					</div>
					<p class="yx-color-text-primary yx-color-text-regular mt-10 fz-14">{{ idUrlCom }}</p>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogMultiVisible = false">取 消</el-button>
				<el-button type="primary" @click="multiConfirm">{{ content }}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import tipsBox from '@/components/common/tipsBox';
import {
	liveRemove,
	confirmUrl,
	productDel,
	cooperationEnd,
	orderRemove,
	cooperateSampleRemove,
	convertUrl,
	confirmation,
} from '@/api/cooperationProgress';
export default {
	name: 'multi',
	components: {
		productBox,
		userInfoBox,
		tipsBox,
	},
	data() {
		return {
			dialogMultiVisible: false,
			title: '',
			state: 0,
			row: {},
			tabName: '',
			width: '25%',
			product_url: '',
			content: '确 定',
			third_product_id: '',
		};
	},
	computed: {
		linkNameCom() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: '如何校验链接？',
				[dataMap.PLATFORM_KS.value]: '如何校验商品机制',
				[dataMap.PLATFORM_SP.value]: '如何校验链接？',
			};
			return temPF[this.platformId] || '';
		},
		goodNameCom() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: '商品带货链接：',
				[dataMap.PLATFORM_KS.value]: '商品id',
				[dataMap.PLATFORM_SP.value]: '商品带货链接：',
			};
			return temPF[this.platformId] || '';
		},
		goodCopyCom() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: '复制链接',
				[dataMap.PLATFORM_KS.value]: '复制商品id',
				[dataMap.PLATFORM_SP.value]: '复制链接',
			};
			return temPF[this.platformId] || '';
		},
		idUrlCom() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: this.product_url,
				[dataMap.PLATFORM_KS.value]: this.third_product_id,
				[dataMap.PLATFORM_SP.value]: this.product_url,
			};
			return temPF[this.platformId] || '';
		},
	},
	methods: {
		async initMulti(row, state, tabName, platformId) {
			this.platformId = platformId;
			this.width = '25%';
			this.tabName = tabName;
			this.row = row;
			this.state = state;
			if (state === 1) {
				//待播表
				this.title = '移除商品';
				this.content = '确 定';
			} else if (state === 2) {
				this.title = '移除选品表';
				this.content = '确认移出选品表';
			} else if (state === 3) {
				this.title = '提前确认收货';
				this.content = '确 定';
			} else if (state === 4) {
				if (this.$isKs()) {
					this.title = '校验商品机制';
					this.content = '确 定';
					this.width = '30%';
					this.third_product_id = row.third_product_id;
					this.dialogMultiVisible = true;
					return;
				}
				if (this.$isSp()) {
					this.title = '校验链接';
					this.content = '确 定';
					this.width = '30%';
					this.product_url = row.product_url;
					this.dialogMultiVisible = true;
					return;
				}
				const { code, data } = await convertUrl({ cooperate_id: row.cooperate_id });
				if (code === 0) {
					this.content = '确 定';
					this.width = '30%';
					this.title = '校验链接';
					this.product_url = data.product_url;
					this.dialogMultiVisible = true;
				}
				return;
			} else if (state === 5 && this.$auth.hasPermi('system:sampleOrder:confirm')) {
				this.content = '确认收货';
				this.title = '确认收货';
			} else if (state === 6) {
				this.title = '结束合作';
				this.content = '确 定';
			} else if (state === 7) {
				this.title = '重新加入选品池';
				this.content = '确 定';
			} else if (state === 8) {
				this.title = '移除商品';
				this.content = '确 定';
			}
			this.dialogMultiVisible = true;
		},
		async multiConfirm() {
			//移除商品待播表
			if (this.state === 1) {
				const { code } = await liveRemove({ cooperate_id: this.row.cooperate_id });
				if (code === 0) {
					this.dialogMultiVisible = false;
					this.$message.success('移除成功');
					this.$emit('refreshList');
				}
			}
			//移除选品表
			if (this.state === 2) {
				let params = {
					product_id: this.row.product_id,
					cooperate_id: this.row.cooperate_id,
				};
				const { code } = await productDel(params);
				if (code === 0) {
					this.dialogMultiVisible = false;
					this.$message.success('移除成功');
					this.$emit('refreshList');
				}
			}
			//校验链接
			if (this.state === 4) {
				const { code } = await confirmUrl({ cooperate_id: this.row.cooperate_id, platform_id: this.row.platform_id });
				if (code === 0) {
					this.dialogMultiVisible = false;
					this.$message.success('校验成功');
					this.$emit('refreshList');
				}
			}
			//确认收货
			if (this.state === 5) {
				const { sample_sn, cooperate_id } = this.row;
				const { code } = await confirmation({ sample_sn, cooperate_id });
				if (code === 0) {
					this.dialogMultiVisible = false;
					this.$message.success('收货成功');
					this.$emit('refreshList');
				}
			}
			//结束合作
			if (this.state === 6) {
				const { code } = await cooperationEnd({ cooperate_id: this.row.cooperate_id });
				if (code === 0) {
					this.dialogMultiVisible = false;
					this.$message.success('结束合作成功');
					this.$emit('refreshList');
				}
			}
			//移除商品待播表
			if (this.state === 8) {
				if (this.row.sampleOrder) {
					const { code } = await orderRemove({ cooperate_id: this.row.cooperate_id, sample_sn: this.row.sample_sn });
					if (code === 0) {
						this.dialogMultiVisible = false;
						this.$message.success('移除成功');
						this.$emit('refreshList');
					}
				} else {
					const { code } = await cooperateSampleRemove({ cooperate_id: this.row.cooperate_id, sample_sn: this.row.sample_sn });
					if (code === 0) {
						this.dialogMultiVisible = false;
						this.$message.success('移除成功');
						this.$emit('refreshList');
					}
				}
			}
		},
		copy() {
			const { third_product_id, product_url } = this;
			const temPF = {
				[dataMap.PLATFORM_DY.value]: product_url,
				[dataMap.PLATFORM_KS.value]: third_product_id,
				[dataMap.PLATFORM_SP.value]: product_url,
				[dataMap.PLATFORM_XHS.value]: product_url,
			};
			this.$copy(temPF[this.platformId] || '');
		
		},
	},
};
</script>
<style lang="less" scoped>
.table {
	margin: 0 auto;
}
.table p {
	width: 100px;
	height: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-bottom: 1px solid #ddd;
	border-left: 1px solid #ddd;
}
.th {
	border-top: 1px solid #ddd;
}
.third {
	border-right: 1px solid #ddd;
}
.line {
	width: 100%;
	height: 1px;
	background-color: #eeeeee;
}
.copy {
	cursor: pointer;
}
</style>
